import {
  SET_IS_ONBOARDING_OPEN,
  SET_IS_FROM_REGISTRATION,
  ADD_SEEN_ROUTE
} from './constants';

const defaultState = {
  isOnboardingOpen: true,
  isFromRegistration: false,
  seenRoutes: []
}

export default (state = defaultState, action) => {
  switch(action.type) {
    case SET_IS_ONBOARDING_OPEN: {
      return {
        ...state,
        isOnboardingOpen: action.status
      }
    }
    case SET_IS_FROM_REGISTRATION: {
      return {
        ...state,
        isFromRegistration: action.status
      }
    }
    case ADD_SEEN_ROUTE: {
      if(state.seenRoutes.includes(action.route)) {
        return state;
      }

      return {
        ...state,
        seenRoutes: [...state.seenRoutes, action.route]
      }
    }
    default: {
      return state;
    }
  }
}
